import { gql } from '@apollo/client/core'

export const NEW_MEMBERSHIP_MUTATION = gql`
  mutation newMembershipBase($input: NewMembershipInput!) {
    newMembership(input: $input) {
      ... on NewMembershipOutput {
        clientSecret
      }
    }
  }
`
